export const santizeUrl = (value: string) => {
  let strippedUrl = value.replace(/^(https?:\/\/)?/, "");
  const host = strippedUrl.split("/")[0];
  return host;
};
